import axios from 'axios';
import { configs } from '../../app/app-configs';
import { Permission } from '../../service/model/role.model';

export const getPermissions = async (): Promise<Permission[]> => {
    return await axios.get(`${configs.BASE_URL}/permission`).then((res) => {
        return res.data as Permission[];
    });
};
